import React from "react";
import SocialLinks from "./SocialLinks";

class Menu extends React.Component {
  render() {
    return (
      <div className="site-nav">
        {/* Main menu */}
        <ul id="nav" className="site-main-menu">
          {/* About Me Subpage link */}
          <li>
            <a
              className="pt-trigger"
              href="#about_me"
              data-animation={59}
              data-goto={1}
            >
              About me
            </a>
          </li>
          {/* /About Me Subpage link */}
          <li>
            <a
              className="pt-trigger"
              href="#resume"
              data-animation={60}
              data-goto={2}
            >
              Resume
            </a>
          </li>
          <li>
            <a
              className="pt-trigger"
              href="#portfolio"
              data-animation={61}
              data-goto={3}
            >
              Portfolio
            </a>
          </li>
          {/* <li>
            <a
              className="pt-trigger"
              href="#blog"
              data-animation={58}
              data-goto={4}
            >
              Blog
            </a>
          </li> */}
          <li>
            <a
              className="pt-trigger"
              href="#contact"
              data-animation={59}
              data-goto={5}
            >
              Contact
            </a>
          </li>
        </ul>
        {/* /Main menu */}
        <SocialLinks/>
      </div>
    );
  }
}

export default Menu;
